import { action, makeObservable, observable } from "mobx";
import { MentorAbsenceViewModel } from "../MentorAbsenceViewModel";

export class MobXManager {
    public _submittedSuccessfully: boolean = false;

    constructor(private viewModel: MentorAbsenceViewModel) {
        makeObservable<MobXManager, "_submittedSuccessfully">(this, {
            _submittedSuccessfully: observable,
            setSubmittedSuccessfully: action,
        });
    }

    public get submittedSuccessfully(): boolean {
        return this._submittedSuccessfully;
    }
    public setSubmittedSuccessfully(value: boolean): void {
        this._submittedSuccessfully = value;
    }
}
